import { render, staticRenderFns } from "./EventNormalFilterModal.vue?vue&type=template&id=06b13942&scoped=true"
import script from "./EventNormalFilterModal.vue?vue&type=script&lang=js"
export * from "./EventNormalFilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b13942",
  null
  
)

export default component.exports